import React from 'react'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import CImage from '../elements/c_image'

const MImage = ({ data }) => {
  const { image, headline, kicker, subheadline } = data || {}
  const hasImage = image && image !== '0'

  if (!hasImage) {
    return null
  }

  return (
    <Section
      baseClass="m-Image"
      className={data.layout === 'umbrella-branding' ? 'm-Image--dachmarke' : ''}
      defaultPadding="large"
      data={data}
    >
      <div className="m-Image-wrapper">
        <div className="m-Image-container">
          <figure className="m-Image-figure">
            {kicker && <DfbHeadline headline={kicker} headline_level="h6" add_class="m-Image-overline" />}
            {headline && <DfbHeadline headline={headline} headline_level="h2" add_class="m-Image-headline" />}
            {subheadline && <DfbHeadline headline={subheadline} headline_level="h4" add_class="m-Image-subline" />}
            <CImage data={data} add_class="m-Image-image" captionClassName={'m-Image-figcaption'} />
          </figure>
        </div>
      </div>
    </Section>
  )
}

export default MImage
